import { render, staticRenderFns } from "./FontControl.vue?vue&type=template&id=a1af06fa&"
import script from "./FontControl.vue?vue&type=script&lang=js&"
export * from "./FontControl.vue?vue&type=script&lang=js&"
import style0 from "./FontControl.vue?vue&type=style&index=0&id=a1af06fa&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports